(function() {
    BlacklistedEmailSearch.$inject = ['$scope', '__env', 'toastr', 'httpService', '$log'];

    angular
    	.module('app')
    	.component('blacklistedEmailSearchComponent', {
    		templateUrl: 'modules/emailSending/components/blacklistedEmailSearch/blacklistedEmailSearch.html',
    		controller: BlacklistedEmailSearch
    	});

    /**
     * Searches for, adds and removes emails from the black list
     *
     * @class BlackListedEmailSearch
     * @param { service } $scope - The scope of the component.
     * @param { service } __env - The environment configuration. 
     * @param { service } toastr - The third party toaster service.
     * @param { service } httpService - The http service used to make asynchronous rest calls
     * @param { service } $log - The service to log to console (or to file if needed).
     */
    function BlacklistedEmailSearch($scope, __env, toastr, httpService, $log) {


    	///////////////////////////////////////////////////////////////////////////
    	// Members
    	///////////////////////////////////////////////////////////////////////////	
    	$scope.showResults = false;
    	$scope.pageTitle = 'Blacklisted Emails';
    	

    	///////////////////////////////////////////////////////////////////////////
    	// Functions
    	///////////////////////////////////////////////////////////////////////////	

    	// columns of the grid
    	var columns = [
    		{
    			field: 'emailAddress',
    			title: 'Email',
    			width: '30%'
    		}, 
    		{
    			field: 'blacklistedDate',
    			title: 'Date Blacklisted',
    			width: '30%'
    		},
    		{ 
    			command: ['destroy'], 
                hidden: !$scope.$parent.pagePermissions.write,
    			title: '&nbsp;', 
    			width: '18%'}
    	];

    	// model to bind to
    	var model = {fields : {
    						'emailAddress': { type: 'string' }						
    					}}; 

    	$scope.blacklistedOptions = { 	
    		autoBind: false,	
            columnMenu: false,        
            columns: columns,        
            editable: true,   
            filterable: {
                extra: false,
                operators: {
                    string: {
                        contains: 'Contains',
                        eq: 'Is equal to'
                    }
                }
            },
            groupable: false,        
            pageable: true,
            remove: deleteEvent,        
            scrollable: true,          
            sortable: true       
        };	

        // commented until the endpoints exist
        $scope.blacklistedSource = 
        {	    	
        	//data: categories
    		type: 'aspnetmvc-ajax',		
            error: function(e) { toastr.error('Could not get blacklisted emails');},	        
    		transport: {
    			read: {				
    				type: 'get',
    				contentType: 'application/json',	
    				url: __env.apiBlacklistedEmails + 'paged/kendo'				              
    			}
    		},			
    		schema: {
                data: 'data',
                total: 'total',            
                model: model,                
            },                        
            pageSize: 10,        
            serverPaging: true,
            serverSorting: true,
            serverFiltering: true        
    	};

    	/**
         * Adds a new email to the blacklist.
         *
         * @function addEmail
         */
    	$scope.addEmail = function() {	

    		// send the new email
    		var email = {
    			emailAddress: $scope.blacklistedEmail
    		};

    		// clear the field
    		$scope.blacklistedEmail = '';

    		var url = __env.apiBlacklistedEmails;
    		var data = email;
    		var type = 'post';

    		httpService.asyncCall(url, type, data)
    			.then(function(response) {
    				// add the email here
    				toastr.success('Email has been successfully added to the blacklist.');	
    				$scope.blacklistedGrid.dataSource.read();

    			}).catch(function(e){
    				toastr.error('Email could not be added to the blacklist.');				
    			});			

    		$scope.showResults = true;
    	};

        /**
         * Hides the email list
         *
         * @function closeEmailList
         */
        $scope.closeEmailList = function() {
            $scope.showResults = false;
        };

    	/**
         * Removes an email from the black list
         *
         * @function removeEmail
         * @param { string } email - the email to be deleted
         */
    	$scope.deleteEmail = function(email) {		

    		var url = __env.apiBlacklistedEmails + email;
    		var data = '';
    		var type = 'delete';

    		httpService.asyncCall(url, type, data)
    			.then(function(response) {				
    				toastr.success('Email has been successfully removed from the blacklist.');				
    				//remove the email here
    			}).catch(function(e){
                    var message = 'Status: ' + e.status + 
                                    '; Error:' + e.statusText;
                                    
                                    
                    $log.error(message);  
    				toastr.error('Email could not be removed from the blacklist.');				
    			});	
    	};

    	/**
         * Handles the delete event fired from the kendo grid
         *
         * @function removeEmail
         * @param { event } e - the kendo delete event
         */
    	function deleteEvent(e) {
    		e.preventDefault();

    		email = e.model.emailAddress;
    		$scope.deleteEmail (email);
    	}
    	
    	/**
         * Searches the black list for an email
         *
         * @function searchEmail
         */
    	$scope.searchEmail = function() {		
    		
    		var email = this.blacklistedEmail;	
    		this.blacklistedEmail = '';

    		if (typeof(email) != 'undefined' && email.length > 0) {
    			

    			$scope.blacklistedGrid.dataSource.filter(
    			{					
    				field: 'emailAddress', 
    				operator: 'contains', 
    				value: email
    			}); 
    		} else {
    			// clear the search and return all fields
    			$scope.blacklistedGrid.dataSource.filter({});
    		}

    		$scope.showResults = true;	
    		
    	};
    }
})();